module.exports = __webpack_public_path__ + "800468bc42538309830d8b8024a9286b.woff2";